import React from "react";

import { type GridColumn } from "ui/Grid/util";

import SelectableGrid from "../SelectableGrid";

export type SelectableGroup = {
  id: string;
  name: string;
  description?: string | null;
};

const searchValue = (group: SelectableGroup) =>
  `${group.name} ${group.description ?? ""}`;

const sortValue = (group: SelectableGroup, field: keyof SelectableGroup) => {
  switch (field) {
    case "description":
      return (group.description ?? "").toLowerCase();
    default:
      return group.name.toLowerCase();
  }
};

const columns: GridColumn<SelectableGroup, keyof SelectableGroup>[] = [
  {
    field: "name",
    header: "Server group",
    width: "minmax(40%,1fr)",
  },
  {
    field: "description",
    header: "Description",
    width: "minmax(30%,1fr)",
    renderer: ({ rowData }) => (
      <span className="text-[#606060]">{rowData.description || "-"}</span>
    ),
  },
];

type Props = {
  groups: SelectableGroup[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
};

// Only custom groups can be included. A cluster group is rejected as a member by
// ServerGroupMembership, and folds in through a cluster_id match rule instead.
const GroupPicker = ({ groups, selectedIds, onChange, disabled }: Props) => (
  <SelectableGrid
    items={groups}
    columns={columns}
    selectedIds={selectedIds}
    onChange={onChange}
    disabled={disabled}
    searchValue={searchValue}
    sortValue={sortValue}
    defaultSortBy="name"
    searchPlaceholder="Search server groups by name or description..."
    emptyMessage="No other server groups to include."
    selectAllLabel="Select all server groups"
    itemLabel={(group) => group.name}
  />
);

export default GroupPicker;
